<ng-container *ngIf="!isMaintenanceMode; else maintenance">
  <div class="app-component-container">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-template #maintenance>
  <app-maintenance-page></app-maintenance-page>
</ng-template>